// Collapses repeated/leading/trailing whitespace so "paracip    650" is
// treated the same as "paracip 650" — both by the backend search API and
// by any client-side substring filtering against product names.
export const normalizeSearchQuery = (value) =>
  (value || "").trim().replace(/\s+/g, " ");
